// extracted by mini-css-extract-plugin
export default {"textContainer":"ResultsCount_textContainer__aks70","icon":"ResultsCount_icon__Hn7uN","mainContainer":"ResultsCount_mainContainer__3w-R1"};